import Helper from "../helpers";

export const MessageStatusError = (status: number) => {
  /**
   * Status trả về (action.status) ---
   * 400: Trùng
   * 401: Hết phiên làm việc
   * 404: Dịch vụ không tồn tại
   * 417: Dữ liệu không tồn tại
   * 500: Lỗi dữ liệu
   * 504: Gateway Time-out
   */
  switch (status) {
    case 400:
      Helper.alertError("Dữ liệu đã tồn tại");
      break;
    case 401:
      Helper.alertError("Hết phiên làm việc, Vui lòng đăng nhập lại!");
      break;
    case 404:
      Helper.alertError("Dữ liệu không tồn tại");
      break;
    case 405:
      Helper.alertError("Dữ liệu không tồn tại");
      break;
    case 409:
      Helper.alertError(
        "Nội dung đưa lên trùng lặp. Vui lòng thay đổi lại trước khi gửi lên."
      );
      break;
    case 415:
      Helper.alertError(
        "Server sẽ không chấp nhận yêu cầu. bởi vì kiểu phương thức không được hỗ trợ."
      );
      break;
    case 416:
      Helper.alertError("Dữ liệu đang được sử dụng");
      break;
    case 417:
      Helper.alertError("Dữ liệu không tồn tại");
      break;
    case 500:
      Helper.alertError("Có lỗi trong quá trình tải dữ liệu");
      break;
    case 503:
      Helper.alertError("Server hiện tại không có sẵn");
      break;
    case 504:
      Helper.alertError("Không nhận được phản hồi từ máy chủ");
      break;
    default:
      break;
  }
};

export const MessageStatusSuccess = (apiType: string) => {
  /**
   * Thông báo (action.apiType) ---
   * LIST: Fetch danh sách
   * ADD: Thêm mới
   * EDIT: Sửa
   * DELETE: Xoá
   * DETAIL: Chi tiết
   */
  switch (apiType) {
    case "ADD":
      Helper.alertSuccessMessage("Thêm mới thành công");
      break;
    case "DELETE":
      Helper.alertSuccessMessage("Xóa thành công");
      break;
    case "EDIT":
      Helper.alertSuccessMessage("Cập nhật thành công");
      break;
    case "SEND":
      Helper.alertSuccessMessage("Gửi thành công");
      break;
    case "APPROVED":
      Helper.alertSuccessMessage("Thành công");
      break;
    default:
      break;
  }
};
